import MainApp from "./MainApp";

export default function App() {
  return <MainApp />;
}
